
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/nft-development",
      function () {
        return require("private-next-pages/services/nft-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/nft-development"])
      });
    }
  